import Api from '../../shared/Api';
import { Promise } from 'es6-promise';
import IProductType from './IProductType';

class ProductTypesApi {
    static list(): Promise<IProductType[]> {
        return new Api().get('/views/producttypes');
    }

    static getNew(): Promise<any> {
        return new Api().get('/views/producttypes/new');
    }

    static create(productType: IProductType): Promise<IProductType> {
        return new Api().post('/views/producttypes', productType);
    }

    static edit(id: number): Promise<any> {
        return new Api().get(`/views/producttypes/${id}/edit`);
    }

    static update(productType: IProductType): Promise<IProductType> {
        return new Api().put(`/views/producttypes/${productType.id}`, productType);
    }

    static delete(id: number): Promise<any> {
        return new Api().delete(`/views/producttypes/${id}`);
    }
}

export default ProductTypesApi;
